/**
 * Checks if two strings are similar by performing a case-insensitive comparison after trimming whitespace.
 * Returns false if either string is undefined.
 *
 * @param a - The first string to compare.
 * @param b - The second string to compare.
 * @returns True if both strings are defined and equal (case-insensitive, trimmed), otherwise false.
 */
export function isSimilar(
  a: string | undefined,
  b: string | undefined,
): boolean {
  if (!a || !b) return false;
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}
